export default __webpack_public_path__ + "static/media/btn-info.9dfa476e.svg";